import { render, staticRenderFns } from "./emails.vue?vue&type=template&id=6455f81a&scoped=true&"
import script from "./emails.vue?vue&type=script&lang=js&"
export * from "./emails.vue?vue&type=script&lang=js&"
import style0 from "./emails.vue?vue&type=style&index=0&id=6455f81a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455f81a",
  null
  
)

export default component.exports